import React, { memo, useEffect, useRef } from "react";

import { useEditorPopupContext } from "../../../contexts/editorPopupsContext";
import type { SlateRenderElementProps } from "../slateTypes";

const PrepareLink: React.FC<SlateRenderElementProps> = memo(props => {
  const { attributes, children } = props;
  const { setCurrentTarget } = useEditorPopupContext();
  const target = useRef(null);
  useEffect(() => {
    if (target.current) {
      setCurrentTarget({
        element: target.current,
        type: "prepareLink",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <span
      className="editor-element__prepare-link"
      data-testid="prepare-link"
      {...attributes}
      ref={target}
    >
      {children}
    </span>
  );
});

export { PrepareLink };
